import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/resource/sort"

const resourceSort = {
  paperSortList(paperType, sortType) {
    return axios.get(pre + `/paperSortList`, {
      params:
        {
          paperType: paperType,
          sortType: sortType,
        }
    });
  },
  savePaperSort(params) {
    return axios.post(pre + `/savePaperSort`, qs.stringify(params));
  },
  paperSortDelete(id) {
    return axios.delete(pre + `/paperSortDelete`, {params: {id: id}});
  },
  topicSortList(sortType) {
    return axios.get(pre + `/topicSortList`, {
      params:
        {
          sortType: sortType,
        }
    });
  },
  saveTopicSort(params) {
    return axios.post(pre + `/saveTopicSort`, qs.stringify(params));
  },
  topicSortDelete(id) {
    return axios.delete(pre + `/topicSortDelete`, {params: {id: id}});
  },
  articleSortList(sortType) {
    return axios.get(pre + `/articleSortList`, {
      params:
        {
          sortType: sortType,
        }
    });
  },
  saveArticleSort(params) {
    return axios.post(pre + `/saveArticleSort`, qs.stringify(params));
  },
  articleSortDelete(id) {
    return axios.delete(pre + `/articleSortDelete`, {params: {id: id}});
  },
}
export default resourceSort;



// WEBPACK FOOTER //
// ./src/api/resource/resourceSort.js